export const LoadingMessage = {
  apiLoading: "Loading your content, Please wait ...",
};
